import { useResetFilters as useResetCurrentFilterInStore } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useSetCurrentFilter } from 'Stores/SavedFiltersStore/SavedFiltersStore';

type UseResetFilters = () => void;

export const useResetFilters = (): UseResetFilters => {
	const setCurrentFilter = useSetCurrentFilter();
	const resetFiltersInStore = useResetCurrentFilterInStore();

	const resetFilters = () => {
		setCurrentFilter(undefined);
		resetFiltersInStore();
	};
	return resetFilters;
};
